





































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ModelFactory from "@/model/ModelFactory";
import ReportModel from "@/model/Report";
import BaseCurrency from "@/components/Base/Controls/BaseCurrency.vue";

const AppStore = namespace("App");
const FormStore = namespace("Form");

@Component({
  name: "ReportRND",
  components: {
    BaseCurrency
  }
})
export default class ReportRND extends Vue {
  @Prop({ required: true })
  readonly value!: ReportModel;

  @FormStore.State
  formDisabled!: boolean;

  private report: ReportModel | null = this.value;

  @AppStore.State
  public reportYear!: number;

  @Watch("value") setValue(newValue: ReportModel) {
    this.report = newValue;
  }

  created() {
    this.report = this.value;
  }

  touch(validator: any) {
    validator && validator.$touch && validator.$touch();
  }
}
